import { styled } from '@mui/material/styles';
import { Table, TableCell } from '@mui/material';
import { Theme } from '@mui/system';

// ==============================|| COMPONENT ||============================== //

export const getStyledTableBorder = (theme: Theme): string =>
  `1px solid ${
    theme.palette.mode === 'dark'
      ? theme.palette.grey['700']
      : theme.palette.grey['200']
  }`;

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? theme.palette.dark.main
      : theme.palette.grey['50'],
  borderRight: getStyledTableBorder(theme)
}));

export const StyledTable = styled(Table)(({ theme }) => ({
  width: '100%',
  borderRadius: theme.spacing(1),
  border: getStyledTableBorder(theme)
}));
